import {GitPullRequestIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Box, Text} from '@primer/react'
import {graphql, usePaginationFragment} from 'react-relay'

import type {ClosedByPullRequestsReferences$key} from './__generated__/ClosedByPullRequestsReferences.graphql'
import {PullRequest} from './PullRequest'

type Props = {
  closedByPullRequestsReferencesKey: ClosedByPullRequestsReferences$key
}

const ClosedByPullRequestsReferencesQuery = graphql`
  fragment ClosedByPullRequestsReferences on Issue
  @argumentDefinitions(closedByPullRequestsReferencesPageSize: {type: "Int"}, cursor: {type: "String"})
  @refetchable(queryName: "ClosedByPullRequestsReferenceQuery") {
    closedByPullRequestsReferences(
      first: $closedByPullRequestsReferencesPageSize
      after: $cursor
      includeClosedPrs: true
    ) @connection(key: "ClosedByPullRequestsReferences__closedByPullRequestsReferences") {
      edges {
        node {
          id
          ...PullRequest
        }
      }
    }
  }
`

export function ClosedByPullRequestsReferences({closedByPullRequestsReferencesKey}: Props) {
  const {data} = usePaginationFragment(ClosedByPullRequestsReferencesQuery, closedByPullRequestsReferencesKey)
  const pullRequests = (data.closedByPullRequestsReferences?.edges || []).flatMap(a => (a && a.node ? a.node : []))

  if (pullRequests.length === 0) return null
  if (pullRequests.length === 1) {
    const pullRequest = pullRequests[0]
    if (pullRequest) return <PullRequest pullRequest={pullRequest} hovercard />
  }
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Box sx={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
          <GitPullRequestIcon size={16} />
          <Text sx={{ml: 1}}>{pullRequests.length}</Text>
        </Box>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList sx={{width: '300px'}}>
          {pullRequests.map(pr => (
            <PullRequest key={pr.id} pullRequest={pr} />
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ ClosedByPullRequestsReferences.displayName ||= 'ClosedByPullRequestsReferences' } catch {}